<script>
    import Button from "./Button.svelte";
  import Sandboxed from "./Sandboxed.svelte";

  export let node;

  let output;

</script>

<div id='container'>
  <Button on:click={async () => {output = await node()}}>Run</Button>

  {#if output}
    <Sandboxed srcdoc={output} />
  {/if}

</div>
<style>
  #container {
    display: flex;
    flex-direction: column;
    height: 98%;
  }
</style>